import React from "react";
// @ts-ignore
import NavBar from "../../screens/SatCourse/CoursesScreen";
// @ts-ignore
import MockTestBanner from "../../components/SatCourse/MockTestBanner";
// @ts-ignore
import QuesIcon from "../../Assets/Images/Sat-images/sat-ins-ques-icon.webp";
// @ts-ignore
import TimerIcon from "../../Assets/Images/Sat-images/mock-ins-timer.webp";

export interface MockInstructionProps {
  isLoading?: boolean;
  isError?: string | boolean;
  Error?: string;
  title: string;
  HandleId: () => void;
}

const MockInstruction: React.FC<MockInstructionProps> = (props) => {
  return (
    <>
      {props.isLoading ? (
        <h1>LOADING.........</h1>
      ) : (
        <div className="Home-Container">
          {props.isError ? (
            <h1>{props.Error}</h1>
          ) : (
            <div className="home-sub-container">
              <div>
                <NavBar />
              </div>
              <div className="main-right-container">
                <div>
                  <MockTestBanner title={props.title} nolesson={"12"} />{" "}
                </div>
                <div className="mock-second-section">
                  <div className="mock-second-left">
                    <div className="second-left-para">
                      <p>Before You Start</p>
                    </div>
                    <div className="mock-left-list">
                      <ol>
                        <li>Tap on options to select the correct answer</li>
                        <li>
                          Once you start the timer, you cannot pause this
                          section.
                        </li>
                        <li>
                          Click submit if you are sure you want to complete all
                          the quizzes
                        </li>
                      </ol>
                    </div>
                    <div
                      className="mock-button "
                      style={{ backgroundColor: "#F5A72C" }}
                      onClick={() => {
                        props.HandleId();
                      }}
                    >
                      Start Your Test
                    </div>
                  </div>
                  <div className="mock-line-div"></div>
                  <div>
                    <div className="mock-ins-right">
                      <div>
                        <img src={QuesIcon} width="30px" height="30px" alt="Questions" />
                      </div>
                      <div className="mock-ins-question-panel">
                        <div className="mock-ins-question">{`27 Question`}</div>
                        <div className="mock-ins-descrip">
                          10 points for a correct answer
                        </div>
                      </div>
                    </div>
                    <div className="mock-ins-right">
                      <div>
                        <img src={TimerIcon} width="30px" height="30px" alt="Timer" />
                      </div>
                      <div className="mock-ins-question-panel">
                        <div className="mock-ins-question">{`27 Question`}</div>
                        <div className="mock-ins-descrip">
                          10 points for a correct answer
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default React.memo(MockInstruction);
